<template>
    <div class="video-list">
        <div class="list-box td-f">
            <div class="video-item td-f" v-for="(item,index) in videoList">
                <div class="index td-fcc">{{index+1}}</div>
<!--                <div class="name td-fcc" @click="goVideoDetail">{{item.name}}</div>-->
                <div class="td-fcc">
                    <router-link tag="a" target="_blank" :to="{path:'/soundVideo',query:{video:item.dir,name:item.name}}" @click="goVideoDetail">{{item.name}}</router-link>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import Lockr from 'lockr'
    import {videoList} from '@/api/soundmark'

    export default {
        name: "progressiveTutorial",
        data(){
          return{
              videoList:'',
          }
        },
        methods: {
            getVideoList() {
                let params = {
                    token: Lockr.get('token'),
                }
                videoList(params).then(result => {
                    if (result.code === this.GLOBAL.Serve.SUCCESS_CODE) {
                        this.videoList = result.data.dataList
                    }else {
                        this.$message({
                            message: result.msg,
                            type: 'warning'
                        });
                    }
                })
            },
            goVideoDetail(){
               // this.$router.resolve('/soundVideo')
                window.open('/soundVideo', '_blank');
            },
        },
        created() {
            this.getVideoList()
        }
    }
</script>

<style scoped lang="less">
    .list-box {
        flex-wrap: wrap;
        border-top: 1px solid #999;

        .video-item {
            width: 49.8%;
            height: 45px;
            font-size: 16px;
            border-bottom: 1px solid #999;

            > div:nth-of-type(1) {
                width: 45px;
                border-right: 1px solid #999;
            }

            > div:nth-of-type(2) {
                padding-left: 10px;
            }
            .name{
                color: #3390ff;
                cursor: pointer;
            }
        }

        .video-item:nth-of-type(odd) {
            border-right: 1px solid #999;
            border-left: 1px solid #999;
        }

        .video-item:nth-of-type(even) {
            border-right: 1px solid #999;
        }
    }

</style>